module.exports = __webpack_public_path__ + "img/wakipharma.6a888f43.jpg";